import { useContext, useEffect, useRef, useState } from 'react';
import { WebApiContext } from 'ascendon-web-api';
import { translateFault, generateUnhandledFault } from '../../helpers/faults';

function useRetrieveProductContext() {
  const [fault, setFault] = useState(null);
  const [uiModel, setUiModel] = useState(null);
  const WebApi = useContext(WebApiContext);

  const isMounted = useRef(true);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  const requestRetrieveProductContext = (newRequestData) => {
    WebApi.subscriber({
      callName: 'RetrieveProductContext',
      keyFactors: ['RetrieveProductContext'],
      forceRefresh: true,
      payload: newRequestData,
    })
      .then((response) => {
        if (isMounted.current) {
          const retrieveProductContext = response.data;
          setUiModel({
            retrieveProductContext,
          });
        }
      })
      .catch((error) => {
        console.warn({ error });
        const code = error?.data?.Code;
        let errorMsg;
        if (!code) {
          const unknownFault = generateUnhandledFault(error.data);
          errorMsg = translateFault(unknownFault).translatedMessage;
          setFault(errorMsg);
        } else {
          errorMsg = translateFault(error.data).translatedMessage;
          setFault(errorMsg);
        }
      });
  };
  return [uiModel, fault, requestRetrieveProductContext];
}

export { useRetrieveProductContext };
export default useRetrieveProductContext;
